export default [{
  key: '*',
  name: '管理员权限',
},

  // Views
{
  key: 'basic.view.*',
  name: '获取所有信息',
}, {
  key: 'basic.view.rooms',
  name: '获取房间信息',
}, {
  key: 'basic.view.contracts',
  name: '获取合同信息',
}, {
  key: 'basic.view.customers',
  name: '获取客户信息',
}, {
  key: 'basic.view.bills',
  name: '获取账单信息',
}, {
  key: 'basic.view.bills.verified',
  name: '获取已审核的账单信息',
}, {
  key: 'basic.view.properties',
  name: '获取库存信息',
}, {
  key: 'basic.view.rents',
  name: '获取房租信息',
}, {
  key: 'basic.view.charges',
  name: '获取水电充值信息',
}, {
  key: 'basic.view.preorders',
  name: '获取预订单信息',
}, {
  key: 'basic.view.notes',
  name: '查看备忘录',
}, {
  key: 'basic.view.usernames',
  name: '获取用户姓名',
},

  // Modify
{
  key: 'basic.modify.rooms.basic',
  name: '修改房屋信息',
}, {
  key: 'basic.modify.rooms.properties',
  name: '修改房物品清单',
}, {
  key: 'basic.modify.rooms.history_notes',
  name: '修改房屋记录',
}, {
  key: 'basic.modify.rooms.tracking_notes',
  name: '修改房屋跟踪记录',
}, {
  key: 'basic.modify.customers',
  name: '修改住户信息',
}, {
  key: 'basic.modify.contracts',
  name: '修改合同信息',
}, {
  key: 'basic.modify.contracts.checkout',
  name: '退房操作',
}, {
  key: 'basic.modify.contracts.preorderable',
  name: '修改可预定状态',
}, {
  key: 'basic.modify.bills',
  name: '修改账单信息',
}, {
  key: 'basic.modify.bills.modify_pending',
  name: '修改待审核状态的账单',
}, {
  key: 'basic.modify.bills.verify',
  name: '确认账单操作',
}, {
  key: 'basic.modify.properties',
  name: '修改库存信息',
},

  // Creates
{
  key: 'basic.create.rents',
  name: '续交房租',
}, {
  key: 'basic.create.contracts',
  name: '签署合同',
}, {
  key: 'basic.create.contracts.discount',
  name: '签署合同时使用优惠方案',
}, {
  key: 'basic.create.preorders',
  name: '签署预订单',
}, {
  key: 'basic.create.charges',
  name: '记录水电充值信息',
}, {
  key: 'basic.create.bills',
  name: '手动建立账单',
},

  // Recall
{
  key: 'basic.recall.contracts',
  name: '撤销合同',
}, {
  key: 'basic.recall.charge',
  name: '撤销水电充值',
}, {
  key: 'basic.recall.rent',
  name: '撤销租金缴交',
},

  // Reports
{
  key: 'basic.reports.meters',
  name: '公寓水电使用报表',
}, {
  key: 'basic.reports.charges',
  name: '水电充值报表',
}, {
  key: 'basic.reports.rents',
  name: '租金报表',
},

  // Hardwares
{
  key: 'hardware.printer.print',
  name: '生成打印文档',
},
{
  key: 'hardware.printer.preview',
  name: '生成打印预览',
},

  // Native
{
  key: 'native.cards.checkin',
  name: '房卡发卡',
},
{
  key: 'native.cards.extension',
  name: '房卡续住',
},
{
  key: 'native.cards.supplement',
  name: '房卡补卡',
},
{
  key: 'native.cards.checkout',
  name: '房卡退卡',
},
{
  key: 'native.cards.skip_vertify',
  name: '办理房卡时跳过身份证验证',
},

  // System
{
  key: 'system.users.list',
  name: '列出全部用户信息',
}, {
  key: 'system.users.view',
  name: '查看用户信息',
}, {
  key: 'system.users.view.senstive',
  name: '查看用户隐私信息',
}, {
  key: 'system.users.edit',
  name: '管理全部用户基础信息',
}, {
  key: 'system.users.permissions',
  name: '管理全部用户权限',
}, {
  key: 'system.self.view',
  name: '查看用户自身信息',
}, {
  key: 'system.self.edit',
  name: '编辑用户自身信息',
},

{
  key: 'system.roles.list',
  name: '列出全部角色信息',
}, {
  key: 'system.roles.view',
  name: '查看角色信息',
}, {
  key: 'system.roles.modify',
  name: '修改角色信息',
},

]



// WEBPACK FOOTER //
// ./shared/permissions.js